import { useEffect, useState } from 'react';

const useLogic = (onChange, getHTML) => {
  const [value, setValue] = useState('');
  const [content, setContent] = useState('');
  const [backdrop, setBackdrop] = useState(false);

  useEffect(() => {
    if (value.length <= 1) {
      if (getHTML) {
        onChange(value.trim());
      }
    } else {
      if (getHTML) {
        onChange(value);
      }
    }
  }, [getHTML, value]);

  useEffect(() => {
    if (!getHTML) {
      if (content.length <= 1) {
        onChange(content.trim());
      } else {
        onChange(content);
      }
    }
  }, [content]);
  const HandleOpenBackdrop = () => {
    setBackdrop(true);
  };
  return {
    value,
    setValue,
    setContent,
    backdrop,
    HandleOpenBackdrop,
    setBackdrop,
  };
};

export default useLogic;
